<template>
    <tooltip :text="tooltipDate" bottom>
        <time class="cursor-pointer w-full whitespace-no-wrap" :class="[textSizeString, textColorString, {'text-center': center, 'text-right': right, 'text-left': left}]" @click="handleClick">{{ displayDate }}</time>
    </tooltip>
</template>

<script>
import TextSizeable from "../../mixins/TextSizeable";
    import Alignable from "../../mixins/Alignable";
    import TextColorable from "../../mixins/TextColorable";

    export default {
        name: "DynamicDate",

        mixins: [TextSizeable, Alignable, TextColorable],

        props: {

            // Whether a short version of the date shall be displayed
            short: {
                type: Boolean,
                default: false
            },

            date: {
                type: [String, Number, Object],
                default: null
            },

            // Whether to show relative dates by default
            relative: {
                type: Boolean,
                default: false
            },

            // Whether to show the time on long format
            time: {
                type: Boolean,
                default: false
            },

            // Whether to disable the relative date display on click
            disableToggle: {
                type: Boolean,
                default: false
            }
        },

        data() {
            return {
                isRelative: this.relative
            }
        },

        computed: {
            dateFormat() {
                return this.short ? 'D. MMM YYYY' : 'D. MMMM YYYY'
            },

            displayDate() {
                if (!this.date || this.date === '-') {
                    return '-'
                }

                if (this.isRelative) {
                    return this.$date(this.date).fromNow()
                }

                return this.$date(this.date).format(this.time ? (this.dateFormat + ' HH:mm') : this.dateFormat)
            },

            tooltipDate() {
                if (!this.date || this.date === '-') {
                    return '-'
                }

                return this.$date(this.date).format(this.time ? 'LLLL' : 'LL')
            }
        },

        watch: {
            relative(relative) {
                this.isRelative = relative;
            }
        },

        methods: {
            handleClick() {
                if (!this.disableToggle) {
                    this.isRelative = !this.isRelative
                }
            }
        }
    }
</script>